var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 16.8438V10.3984M11.6875 16.8438V6.53125M16.8438 16.8438V14.2656M19.4219 1.375H3.95312C3.26936 1.375 2.61361 1.64662 2.13012 2.13012C1.64662 2.61361 1.375 3.26936 1.375 3.95312V19.4219C1.375 20.1056 1.64662 20.7614 2.13012 21.2449C2.61361 21.7284 3.26936 22 3.95312 22H19.4219C20.1056 22 20.7614 21.7284 21.2449 21.2449C21.7284 20.7614 22 20.1056 22 19.4219V3.95312C22 3.26936 21.7284 2.61361 21.2449 2.13012C20.7614 1.64662 20.1056 1.375 19.4219 1.375Z",
    stroke: "#1F2F3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageAnalytics);
export default __webpack_public_path__ + "static/media/page-analytics.4be98b71e63e296025bb91e922f160c2.svg";
export { ForwardRef as ReactComponent };